import sum from 'ramda/src/sum'

/** constants used for the scoring function */
const COUNT_WEIGHT = 1
const DATE_PENALTY = 2
const PROJECT_WEIGHT = 15
const PROJECT_DATE_PENALTY = 3

const daysAgo = (time, now) => {
  return Math.round((now - time) / (1000 * 3600 * 24))
}

const computeProjectWeights = (projects, now = Date.now()) => {
  const weights = {}
  projects.forEach(p => {
    weights[p._id] = Math.max(PROJECT_WEIGHT - PROJECT_DATE_PENALTY * daysAgo(p.updatedAt, now), 0)
  })
  return weights
}

const computeScore = (count, date, projectIds, projectWeights, now = Date.now()) => {
  return count - DATE_PENALTY * daysAgo(date, now) + sum(projectIds.map(id => projectWeights[id] || 0))
}

export default function computeScores({ recentModels, projects }) {
  const weights = computeProjectWeights(projects)

  return recentModels.map(model => {
    return {
      ...model,
      score: computeScore(model.count, model.date, model.projectIds, weights)
    }
  })
}

export function findLowestScore(recentModels, projects, now) {
  const projectWeights = computeProjectWeights(projects, now)
  let lowest = recentModels[0]
  let lowScore = computeScore(lowest.count, lowest.date, lowest.projectIds, projectWeights, now)

  recentModels.forEach((model) => {
    const score = computeScore(model.count, model.date, model.projectIds, projectWeights, now)
    if (score < lowScore || (score === lowScore) && (model.date < lowest.date)) {
      lowScore = score
      lowest = model
    }
  })
  return lowest
}



// WEBPACK FOOTER //
// ./src/helpers/cameras/computeRecentScore.js